import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appearsIn"];
import { Tag } from 'foundations-components/transitional/components/Tag';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { Flex } from 'foundations-components/components/Flex';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterTag = ({
  filter,
  value,
  appearsIn
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handleRemoveFilter = () => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-deselected',
      value,
      isDropdown: false,
      key: filter,
      appearsIn
    });
    if (Array.isArray(searchParams[filter])) {
      setSearchParams({
        [filter]: searchParams[filter].filter(v => v !== value)
      });
    } else {
      setSearchParams({
        [filter]: undefined
      });
    }
  };
  return /*#__PURE__*/_jsxs(Tag, {
    closeable: true,
    inline: true,
    margin: "0",
    onCloseClick: handleRemoveFilter,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.topFilters.${filter}.filterTitle`
    }), ":", ' ', /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.topFilters.${filter}.${value}`
    })]
  });
};
export const FilterTags = _ref => {
  let {
      appearsIn
    } = _ref,
    options = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [searchParams] = useSearchParams();

  // valid filters to show as tags
  const filters = Object.keys(searchParams).filter(key => Object.values(FILTER_TYPES).includes(key) && key !== FILTER_TYPES.SEARCH);
  if (!filters.length) return null;
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    columnGap: "400",
    flexWrap: "wrap",
    rowGap: "200"
  }, options, {
    children: filters.map(filter => {
      const value = searchParams[filter];
      if (Array.isArray(value)) {
        return value.map(v => /*#__PURE__*/_jsx(FilterTag, {
          appearsIn: appearsIn,
          filter: filter,
          value: v
        }, `${filter}-${v}`));
      }
      return /*#__PURE__*/_jsx(FilterTag, {
        appearsIn: appearsIn,
        filter: filter,
        value: value
      }, `${filter}-${value}`);
    })
  }));
};